import { MeetingsAPI } from "../infrastructure/api/Meetings.api";

export { meetingJoinFailureFrom } from "../infrastructure/api/meetingJoinFailure";
export { MEETING_ROOM_OPTIONS } from "../infrastructure/meetingRoomOptions";

/**
 * The doors into an AlchelyMeeting room and the switches a session's room
 * has. Each answers with the response's data; a failed request rejects with
 * the original error, which `meetingJoinFailureFrom` reads.
 */

/** The therapist's own token for a booking they own. */
export async function requestTherapistMeetingToken(appointmentId: string) {
    const { data } = await MeetingsAPI.therapistToken(appointmentId);
    return data;
}

/** A therapist's token for a session started on the spot, with no booking. */
export async function requestSessionMeetingToken(sessionId: string) {
    const { data } = await MeetingsAPI.therapistSessionToken(sessionId);
    return data;
}

/** The session a booking is held as, created the first time it is asked for. */
export async function sessionForAppointment(appointmentId: string) {
    const { data } = await MeetingsAPI.sessionForAppointment(appointmentId);
    return data;
}

/** A guest joining from the link itself; the token in the URL is the authorisation. */
export async function requestGuestMeetingToken(token: string, displayName: string) {
    const { data } = await MeetingsAPI.guestToken(token, displayName);
    return data;
}

/** Say that the room is up, which is the first moment it can be recorded. */
export async function startSessionMeeting(sessionId: string) {
    const { data } = await MeetingsAPI.startSessionMeeting(sessionId);
    return data;
}

/** Close a session's room for everyone in it. */
export async function endSessionMeeting(sessionId: string) {
    const { data } = await MeetingsAPI.endSessionMeeting(sessionId);
    return data;
}

/** The therapist's own "not this one", for a single session. */
export async function setSessionTranscription(sessionId: string, enabled: boolean) {
    const { data } = await MeetingsAPI.setSessionTranscription(sessionId, enabled);
    return data;
}
